import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface AllReportsCounterProps {
  notCreated: number;
  late: number;
  inDraft: number;
}

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  text-align: center;
  min-width: 500px;
`;

const CounterBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Number = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: var(--sumi-text-primary);
`;

const Description = styled.div`
  font-size: 16px;
  color: var(--sumi-text-secondary);
`;

const AllReportsCounter: React.FC<AllReportsCounterProps> = ({
  notCreated,
  late,
  inDraft,
}) => {
  const { t } = useTranslation();
  return (
    <GridContainer>
      <CounterBox>
        <Number>{notCreated}</Number>
        <Description>{t("label-not-created")}</Description>
      </CounterBox>
      <CounterBox>
        <Number>{late}</Number>
        <Description>{t("label-late")}</Description>
      </CounterBox>
      <CounterBox>
        <Number>{inDraft}</Number>
        <Description>{t("label-in-draft")}</Description>
      </CounterBox>
    </GridContainer>
  );
};

export default AllReportsCounter;
